// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JIMnFGJKSAnavz4WI39XY","restaurantManagersList":"_1OpWQn2DCI2W8TIrzmEoKY","item":"_3AIyN8O1eI_gqsDH4s80eB","dot":"BMzPCFefNk0q_AqkmozLm"};